// extracted by mini-css-extract-plugin
export default {"loaderContainer":"Loader_loaderContainer__FPb+4","loader":"Loader_loader__1mRnw","spin":"Loader_spin__+wOqx"};